import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../../ApiService';
import { DepartmentList } from '../../../../entities/v1/DepartmentList';
import { HiringMemberList } from '../../../../entities/v1/HiringMemberList';
import { SurveyTemplateList } from '../../../../entities/v1/survey_engine/SurveyTemplateList';
import { JobList } from '../../../../entities/v1/JobList';
import { LocationList } from '../../../../entities/v1/LocationList';

interface Params {
  name?: string;
  page?: number;
  pageSize?: number;
}

interface HiringMemberParams extends Params {
  role?: string;
}

export class AnalyticsFiltersService {
  public static locations(params: Params) {
    return ApiService.get<LocationList>(
      '/api/v1/candidate_experience/analytics/locations',
      snakecaseKeys(params),
    );
  }

  public static jobs(params: Params) {
    return ApiService.get<JobList>(
      '/api/v1/candidate_experience/analytics/jobs',
      snakecaseKeys(params),
    );
  }

  public static hiringManagers(params: Params) {
    return AnalyticsFiltersService.hiring_members({
      role: 'hiring_manager',
      ...params,
    });
  }

  public static recruiters(params: Params) {
    return AnalyticsFiltersService.hiring_members({
      role: 'recruiter',
      ...params,
    });
  }

  public static hiring_members(params: HiringMemberParams) {
    return ApiService.get<HiringMemberList>(
      '/api/v1/candidate_experience/analytics/hiring_members',
      snakecaseKeys(params),
    );
  }

  public static departments(params: Params) {
    return ApiService.get<DepartmentList>(
      '/api/v1/candidate_experience/analytics/departments',
      snakecaseKeys(params),
    );
  }

  public static surveyTemplates(params: Params) {
    return ApiService.get<SurveyTemplateList>(
      '/api/v1/candidate_experience/analytics/survey_templates',
      snakecaseKeys(params),
    );
  }
}
